import { tv } from '@/common/theme/tv.config';

export const styles = {
  host: tv({
    base: 'border border-[transparent]',
    variants: {
      error: {
        true: 'border border-systemError',
      },
      warning: {
        true: 'border border-systemWarning',
      },
    },
  }),
};
